import * as React from "react";
import { Schema } from "@cak-legacy/generation-core";
import { EmailValidation, RegexValidation } from "@cak-legacy/generation-form";
import {
  IBaseFormSchemaModel,
  IsRequiredValidationFactory,
  HasMaxLengthValidationFactory,
  translate,
  DateValidationFactory,
  iconInfoClasses,
  RepeatEmailFieldValidation,
  DateNotInFutureValidationFactory,
  HasSpecificLengthValidationFactory
} from "@klantondersteuning-btl/shared";
import { AutoCompleteEnum, ExcludeCharacterFilterTypes } from "@cak-legacy/shared-common";

export interface EhicFormulierSchemaModel extends IBaseFormSchemaModel {
  persoonlijkDossier: {
    CAKIDnummer: string;
    geboorteDatum: string;
  };
  contactgegevens: {
    emailAdres: string;
    emailAdresControle: string;
  };
}

export const ehicFormulierSchema = (): Schema => {
  return {
    persoonlijkDossier: {
      type: "object",
      ui: {
        flexDirection: "column",
        theme: "light"
      },
      properties: {
        CAKIDnummer: {
          type: "text",
          label: translate("CAKIDnummer"),
          dontShowMaxLengthReachedMessage: true,
          excludeCharactersFilter: ExcludeCharacterFilterTypes.Numbers,
          validate: [
            IsRequiredValidationFactory(),
            HasMaxLengthValidationFactory(8),
            HasSpecificLengthValidationFactory(8),
            new RegexValidation(false, "^(?!00000000$).*")
          ],
          popupHint: {
            icon: iconInfoClasses,
            text: translate("CAKIDnummerInfoTxt")
          }
        },
        geboorteDatum: {
          type: "date",
          label: translate("GeboorteDatum"),
          validate: [
            DateValidationFactory(false),
            DateNotInFutureValidationFactory(false),
            IsRequiredValidationFactory()
          ]
        }
      }
    },
    contactgegevens: {
      type: "object",
      ui: {
        flexDirection: "column",
        theme: "light"
      },
      properties: {
        emailAdres: {
          type: "text",
          label: translate("EmailAdres"),
          autoComplete: AutoCompleteEnum.emailAdres,
          validate: [IsRequiredValidationFactory(), new EmailValidation(), HasMaxLengthValidationFactory()]
        },
        emailAdresControle: {
          type: "text",
          label: translate("EmailAdresControle"),
          autoComplete: AutoCompleteEnum.off,
          validate: [
            IsRequiredValidationFactory(),
            new EmailValidation(),
            HasMaxLengthValidationFactory(),
            new RepeatEmailFieldValidation()
          ]
        }
      }
    }
  };
};
